import Toolbar from "../../../../../layout/toolbar";
import ToolbarTitle from "../../../../../layout/toolbar-title";
import VerticalUiContainer from "../../../../../layout/vertical-ui-container";
import Text from "../../../../../common/text";
import InfiniteScrollList from "../../../../../common/infinite-scroll-list";
import MessageInfiniteScrollList from "../message-infinite-scroll-list";
import style from "./styles.scss";
import EmailOutlineIcon from "mdi-preact/EmailOutlineIcon";

export default class MessageList extends InfiniteScrollList {
    render(props, state, context) {
        return (
            <VerticalUiContainer>
                <Toolbar class={style.toolbar}>
                    <div className={style.iconButton}><EmailOutlineIcon/></div>
                    <ToolbarTitle><Text text={'message.list'}/></ToolbarTitle>
                </Toolbar>
                <MessageInfiniteScrollList />
            </VerticalUiContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/messenger/message-list/index.js